import { render, staticRenderFns } from "./CopOrderView.vue?vue&type=template&id=10c2e464"
import script from "./CopOrderView.vue?vue&type=script&lang=js"
export * from "./CopOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports